module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av243-d4cc28bfe19e3219b7f53ba0a3dbb17e.jpg";